export enum RemedialStatus {
  New = "New",
  PendingInformation = "PendingInformation",
  PendingApproval = "PendingApproval",
  Approved = "Approved",
  Rejected = "Rejected",
  Complete = "Complete",
  TraceRequest = "TraceRequest",
  CreatedInAdminbase = "CreatedInAdminbase"
}

